import { render, staticRenderFns } from "./HasLaundryRoom.vue?vue&type=template&id=0954baea&"
import script from "./HasLaundryRoom.vue?vue&type=script&lang=ts&"
export * from "./HasLaundryRoom.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports